import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=785387fc&scoped=true"
import script from "./multi-select.vue?vue&type=script&lang=js"
export * from "./multi-select.vue?vue&type=script&lang=js"
import style0 from "./multi-select.vue?vue&type=style&index=0&id=785387fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785387fc",
  null
  
)

export default component.exports